import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { getAllCategorys } from "../../../redux/actions/categories";
import { getReport, getMonth } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
 import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class SalesPerformance extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'SALES_PERFORMANCE',
      path: ["Home", "Buyer Metrics Report"],
      links: ["home", "report/buyer"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      monthData: [],
      csvData: "",
      reportData: "",
      dealType: "",
      showValue: "",
      isLoading: "false",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleDealType = this.handleDealType.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange

  handleDealType(e) {
    isLoading = "true";
    this.setState({
      dealType: e.target.value
    });
    this.props.getReport({selectMonth:this.state.selectMonth, dealType:e.target.value}, 'report/past-month-sales-performance');
  }

  // Handle input onchange
  handleChange(e) {
    isLoading = "true";
    this.setState({
      selectMonth: e.target.value
    });
    this.props.getReport({selectMonth: e.target.value, dealType:this.state.dealType}, 'report/past-month-sales-performance');
  }

  componentWillMount() {
    isLoading = "true"
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getMonth();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.combine_products == 'disable') {
        this.setState({dealType: 'offer'})
      }
    }
  }

  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ sales: "" });
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ reportData: nextProps.reportData });
        this.handleExport(nextProps.reportData);
      }
    }

    if (this.props.MonthData !== nextProps.MonthData) {
      if (nextProps.MonthData) {
        isLoading = "false";
        this.setState({ monthData: nextProps.MonthData });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleExport = data => {
    let setDate = (this.state.range == true) ? moment(this.state.startDate).format('MM/DD/YYYY') +' - '+moment(this.state.endDate).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
          'title',
          'Gross Billing',
          'Merchant Remittance',
          'Revenue',
          'Offers Ran',
          'Unique Merchants',
          'Rev/Unique Merchant',
          'Deals Quantity',
          'Average Price',
          'Total Buyers',
          'Average Discount',
          'New Buyers',
          'Average Take Rate',
          'Vouchers Sold',
      ]
    ];
    {data &&
      data.data.map((dataValue, index) =>
        Object.keys(dataValue).map((key, indexkey) => 
          (key == 'title') ?
            ''
          :
          data.data[index][key].map((detail, dkey) => 
            csvData.push([
              (data.data[index]['title'] ? data.data[index]['title'] : ''),
              detail.gross_billing,
              detail.merchant_remittance,
              detail.revenue,
              detail.offers_ran,
              detail.unique_merchants,
              detail.rev_unique_merchant,
              detail.deals_quantity,
              detail.average_price, 
              detail.total_buyers,
              detail.average_discount,
              detail.new_buyers,
              detail.average_take_rate,
              detail.vouchers_sold,
            ])
          )
        )
      )
    }

    this.setState({ csvData: csvData });
  };

  showData = (value) => {
    this.setState({showValue: value});
  }

  hideData = () => {
    this.setState({showValue: ''});
  }

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Sales Performance Report
            <span className="pull-right">
              <FormControl componentClass="select" name="month" onChange={this.handleChange} value={this.state.month}>
                <option value="">Select Month</option>
                {(!isEmpty(this.state.monthData)) && 
                  this.state.monthData.data.map((month, index) => 
                    <option key={index} value={month}>{month}</option>
                  )
                }
              </FormControl>
            </span>
            <span className="pull-right">
              <FormControl componentClass="select" name="dealType" onChange={this.handleDealType} value={this.state.dealType}>
                  <option value="">All</option>
                  <option value="offer">Offer</option>
                  <option value="products">Products</option>
              </FormControl>
            </span>
            <span className="pull-right">
              {this.state.csvData ? (
                <CSVLink
                  data={this.state.csvData}
                  filename={"sales-performance-report.csv"}
                  className="btn btn-danger"
                >
                  Export CSV
                </CSVLink>
              ) : null}
            </span>
            </header>
            <div className="panel-body table-responsive col-lg-12 ">
              <table className="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th>title</th>
                    <th>Gross Billing</th>
                    <th>Merchant Remittance</th>
                    <th>Revenue</th>
                    <th>Offers Ran</th>
                    <th>Unique Merchants</th>
                    <th>Rev/Unique Merchant</th>
                    <th>Deals Quantity</th>
                    <th>Average Price</th>
                    <th>Total Buyers</th>
                    <th>Average Discount</th>
                    <th>New Buyers</th>
                    <th>Average Take Rate</th>
                    <th>Vouchers Sold</th>
                  </tr>
                </thead>
                <tbody>
                {this.state.reportData ?
                  this.state.reportData.data.map((data, index) =>
                    Object.keys(data).map((key, indexkey) =>  (key == 'title') ?
                      ''
                    :
                      this.state.reportData.data[index][key].map((detail, dkey) => 
                        <tr key={key+index} /*style={{display: (this.state.showValue == index && this.state.showValue !== '') ? '' : 'none' }} */>
                          <td>{this.state.reportData.data[index]['title'] ? this.state.reportData.data[index]['title'] : ''}</td>
                          <td>{detail.gross_billing}</td>
                          <td>{detail.merchant_remittance}</td>
                          <td>{detail.revenue}</td>
                          <td>{detail.offers_ran}</td>
                          <td>{detail.unique_merchants}</td>
                          <td>{detail.rev_unique_merchant}</td>
                          <td>{detail.deals_quantity}</td>
                          <td>{detail.average_price}</td>
                          <td>{detail.total_buyers}</td>
                          <td>{detail.average_discount}</td>
                          <td>{detail.new_buyers}</td>
                          <td>{detail.average_take_rate}</td>
                          <td>{detail.vouchers_sold}</td>
                        </tr>
                      )
                    )
                  )
                  :
                  <tr><td colSpan="14">Data Not Found</td></tr>
                }
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
    MonthData: state.reportReducer.MonthData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
    getMonth 
  })
)(SalesPerformance);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/SalesPerformance.js